import { render, staticRenderFns } from "./Parrafo.vue?vue&type=template&id=bcd450b0&scoped=true&"
import script from "./Parrafo.vue?vue&type=script&lang=js&"
export * from "./Parrafo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd450b0",
  null
  
)

export default component.exports